// extracted by mini-css-extract-plugin
module.exports = {"paginationRow":"Paginate_paginationRow__1v-pz","pageSize":"Paginate_pageSize__3XwEh"};